import React, { FC, useCallback } from "react";
import { Container } from "../../components/container/container";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import "./category-banner.css";
import { Category } from "@xvia/webgate-connect";

export interface CategoryProps {
  categoryList: Category[];
  onClickHeader: () => void;
  onClickCategory: (category: Category) => void;
  onClickMunicipalityCitiesBanner?: () => void;
  isOpen?: boolean;
  headerSubtitle?: string;
  municipalityCitiesSubtitle?: string;
  showMunicipalityCitiesBanner?: boolean;
  hideChevron?: boolean;
}

export const CategoryBanner: FC<CategoryProps> = ({
  categoryList,
  isOpen,
  onClickHeader,
  onClickCategory,
  onClickMunicipalityCitiesBanner,
  headerSubtitle = "Clique para expandir",
  municipalityCitiesSubtitle = "Clique para acessar",
  showMunicipalityCitiesBanner = false,
  hideChevron = false,
}) => {
  const baseClassName = classNames({
    "xvia-category-banner": true,
    "xvia-category-banner--open": isOpen,
  });

  const onClickItem = useCallback(
    (category: Category) => {
      return () => onClickCategory(category);
    },
    [onClickCategory]
  );

  return (
    <div style={{ paddingTop: 24 }}>
      <Container className="xvia-category-services__container">
        <div className={baseClassName}>
          <button
            className="xvia-category-banner__header"
            style={{
              backgroundImage: `url("${process.env.PUBLIC_URL}/images/svgs/bg-categories.svg")`,
            }}
            onClick={onClickHeader}
          >
            <div
              className="xvia-category-banner__header-icon"
              style={{
                backgroundImage: `url("${process.env.PUBLIC_URL}/images/svgs/categories-icon.svg")`,
              }}
            />
            <div className="xvia-category-banner__header-text">
              <div className="xvia-category-banner__header-title">
                Todos os serviços por categoria
                {!hideChevron && (
                  <span>
                    <FontAwesomeIcon
                      width={16}
                      height={16}
                      icon={isOpen ? faChevronUp : faChevronDown}
                    />
                  </span>
                )}
              </div>
              <div className="xvia-category-banner__header-subtitle">
                {headerSubtitle}
              </div>
            </div>
          </button>
          <div className="xvia-category-banner__content">
            <ul className="xvia-category-banner__list">
              {categoryList?.map((category) => {
                return (
                  <li
                    className="xvia-category-banner__list-item"
                    key={category.id}
                  >
                    <button onClick={onClickItem(category)}>
                      {category.name}
                    </button>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        {showMunicipalityCitiesBanner && (
          <div className="xvia-category-banner xvia-category-banner--municipality-cities">
            <button
              className="xvia-category-banner__header xvia-category-banner__header--municipality-cities"
              style={{
                backgroundImage: `url("${process.env.PUBLIC_URL}/images/svgs/bg-categories-municipios.svg")`,
              }}
              onClick={onClickMunicipalityCitiesBanner}
            >
              <div
                className="xvia-category-banner__header-icon xvia-category-banner__header-icon--municipality-cities"
                style={{
                  backgroundImage: `url("${process.env.PUBLIC_URL}/images/svgs/categories-icon.svg")`,
                }}
              />
              <div className="xvia-category-banner__header-text">
                <div className="xvia-category-banner__header-title">
                  Todas as cidades no Gov.pi
                </div>
                <div className="xvia-category-banner__header-subtitle">
                  {municipalityCitiesSubtitle}
                </div>
              </div>
            </button>
          </div>
        )}
      </Container>
    </div>
  );
};
